import {BaseStore, globalStore} from "../../stem-core/state/Store";
import {field} from "../../stem-core/state/StoreField";
import {apiClient, type MerchantScopedRequest} from "../connection/BlinkApiClient";
import type {StoreId} from "../../stem-core/state/State";

@globalStore
export class SubscriptionBenefit extends BaseStore("SubscriptionBenefit") {
    @field(String) name: string;
    @field(String) description: string;
    @field(String) alias: string;

    toString(): string {
        return this.name;
    }

    toUI(): string {
        return this.toString();
    }

    serializeForSDK() {
        return {
            id: this.id,
            name: this.name,
            description: this.description,
            alias: this.alias,
        }
    }
}

// CreateSubscriptionBenefitRequest (api/merchants/views.py)
export interface CreateSubscriptionBenefitRequest extends MerchantScopedRequest {
    name: string;
    alias?: string;
    description?: string;
}

export async function apiMerchantCreateSubscriptionBenefit(request: CreateSubscriptionBenefitRequest): Promise<SubscriptionBenefit> {
    const response = await apiClient.post("/merchant/create_subscription_benefit/", request);
    return SubscriptionBenefit.loadObject(response);
}

// EditSubscriptionBenefitRequest, the same plus the id. name stays required on the edit too
export interface EditSubscriptionBenefitRequest extends CreateSubscriptionBenefitRequest {
    benefitId: StoreId;
}

export async function apiMerchantEditSubscriptionBenefit(request: EditSubscriptionBenefitRequest): Promise<any> {
    return apiClient.post("/merchant/edit_subscription_benefit/", request);
}
